import {Navigate, useLocation} from 'react-router-dom'
import {useMainStore} from 'src/contexts/Main'
import {PATH_AUTH} from 'src/routes/paths'
import CuiLoading from '../custom/CuiLoading'
import {observer} from 'mobx-react-lite'

const ProtectedRoute = observer(function ProtectedRoute({children}: any) {
  const location = useLocation()
  const {loginStore} = useMainStore()
  const isTestMode = localStorage.getItem('test-mode') === 'true'

  if (loginStore.isAuth || isTestMode) return children

  // The session is resolved asynchronously (a silent sign-in for the edge gate's account may
  // be running) - do not bounce to /login before that is done.
  if (loginStore.isInitializing) return <CuiLoading />

  if (loginStore.isAccessDenied) return <Navigate to={PATH_AUTH.accessDenied} />

  if (loginStore.isMsalAuth && !loginStore.shouldLogout) {
    return <CuiLoading />
  }

  return <Navigate to="/login" state={{from: location.pathname}} />
})

export default ProtectedRoute
